/* @flow */

//----------------------------------------------------------------------//
// GLOBAL IMPORTS
//----------------------------------------------------------------------//

import * as React from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import type { TranslatorProps } from 'react-i18next';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//
import CollectionDetails from '../../components/CollectionDetails/CollectionDetails';
import DetailsPanel from '../../../NotificationsReview/panels/DetailsPanel/DetailsPanel';
import styles from '../../../NotificationsReview/panels/DetailsPanel/DetailsPanel.module.scss';

//----------------------------------------------------------------------//
// UTILS
//----------------------------------------------------------------------//
import { errorHandlerService } from 'services/ServiceRegistry';

@translate()
export default class AssetFaultReportRequest extends React.Component<*> {
  render(): React.Element<*> {
    const { data, t } = this.props;
    const asset = data.details.contract.assets[0];

    return (
      <React.Fragment>
        <DetailsPanel data={data} />

        <div className={styles['details-panel']}>
          <div className={styles['container']}>
            {data.details.fault_details && (
              <div className={`${styles['list-container']} fault-report`}>
                <b>{t('general:labels.fault_report')}</b>
                <ul>
                  <li>{data.details.fault_details}</li>
                </ul>
              </div>
            )}

            <CollectionDetails asset={asset} />

            <div className={`${styles['list-container']} additional-info`}>
              <b>{t('general:labels.additional_info')}</b>
              <ul>
                <li>
                  {t('general:labels.replacement_asset_required')}: {asset.replacement_required}
                </li>
                <li>
                  {t('general:assets.reasons.original_packaging')}: {asset.keep_original_packaging}
                </li>
                <li>
                  {t('general:labels.packaging_details')}: {asset.packaging_description}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
